export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.109 2.7a.4.4 0 00-.568.001L12.2 4.051l4.255 4.253 1.348-1.347a.401.401 0 000-.567L14.109 2.7zm.93 7.018l-4.252-4.25L2.5 13.75V18h4.253l8.286-8.282zm4.176-1.346a2.4 2.4 0 000-3.397l-3.692-3.69a2.4 2.4 0 00-3.4.006L10.08 3.346l-.003.002-9.284 9.28a1 1 0 00-.293.707V19a1 1 0 001 1h5.667a1 1 0 00.707-.293L19.215 8.372z" />
  `,
  title: 'Pencil',
  viewBox: '0 0 21 20',
};
